module.exports = __webpack_public_path__ + "img/cancelamento-eletronico.5c3387ae.svg";